/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CopyRecallDto } from '../models/CopyRecallDto';
import type { Int32_StringValueTuple } from '../models/Int32_StringValueTuple';
import type { ManufacturerVinRecallTableDtoPagedListData } from '../models/ManufacturerVinRecallTableDtoPagedListData';
import type { RecallBrandCodeDto } from '../models/RecallBrandCodeDto';
import type { RecallDtoPagedListData } from '../models/RecallDtoPagedListData';
import type { RecallInput } from '../models/RecallInput';
import type { RecallLabourDto } from '../models/RecallLabourDto';
import type { RecallLabourInput } from '../models/RecallLabourInput';
import type { RecallStatus } from '../models/RecallStatus';
import type { SingleRecallDto } from '../models/SingleRecallDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ManufacturerVinRecallService {

  /**
   * Create vin recall record
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postManufacturerVinRecallCreate(
requestBody?: RecallInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/manufacturer-vin-recall/create',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * Get table data
   * @param code 
   * @param name 
   * @param timeIntervalFrom 
   * @param timeIntervalTo 
   * @returns ManufacturerVinRecallTableDtoPagedListData Success
   * @throws ApiError
   */
  public static getManufacturerVinRecall(
code?: string,
name?: string,
timeIntervalFrom?: string,
timeIntervalTo?: string,
): CancelablePromise<ManufacturerVinRecallTableDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/manufacturer-vin-recall',
      query: {
        'Code': code,
        'Name': name,
        'TimeIntervalFrom': timeIntervalFrom,
        'TimeIntervalTo': timeIntervalTo,
      },
    });
  }

  /**
   * Export recall record CSV
   * @param id 
   * @returns string Success
   * @throws ApiError
   */
  public static getManufacturerVinRecallCsv(
id: number,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/manufacturer-vin-recall/{id}/csv',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Export recall to phonecall
   * @param id 
   * @returns any Accepted
   * @throws ApiError
   */
  public static getManufacturerVinRecallPhonecall(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/manufacturer-vin-recall/{id}/phonecall',
      path: {
        'id': id,
      },
      errors: {
        401: `Unauthorized`,
      },
    });
  }

  /**
   * Read uploaded excel file and return list of cell values
   * @param formData 
   * @returns string Success
   * @throws ApiError
   */
  public static postManufacturerVinRecallReadUploadedExcelFile(
formData?: {
file: Blob;
},
): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/manufacturer-vin-recall/read-uploaded-excel-file',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postRecalls(
requestBody?: RecallInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/recalls',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param status
 *
 * 0 = Closed
 *
 * 1 = Active
   * @param brandCodeId 
   * @param dateFrom 
   * @param dateTo 
   * @param recallNo 
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @returns RecallDtoPagedListData Success
   * @throws ApiError
   */
  public static getRecalls(
status?: RecallStatus,
brandCodeId?: number,
dateFrom?: string,
dateTo?: string,
recallNo?: string,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
): CancelablePromise<RecallDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/recalls',
      query: {
        'Status': status,
        'BrandCodeId': brandCodeId,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'RecallNo': recallNo,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns SingleRecallDto Success
   * @throws ApiError
   */
  public static getRecalls1(
id: number,
): CancelablePromise<SingleRecallDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/recalls/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putRecalls(
id: number,
requestBody?: RecallInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/recalls/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static deleteRecalls(
id: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/recalls/{id}',
      path: {
        'id': id,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postRecallsLabours(
id: number,
requestBody?: RecallLabourInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/recalls/{id}/labours',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param recallId 
   * @param labourId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putRecallsLabours(
recallId: number,
labourId: number,
requestBody?: RecallLabourDto,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/recalls/{recallId}/labours/{labourId}',
      path: {
        'recallId': recallId,
        'labourId': labourId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param recallId 
   * @param labourId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteRecallsLabours(
recallId: number,
labourId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/recalls/{recallId}/labours/{labourId}',
      path: {
        'recallId': recallId,
        'labourId': labourId,
      },
      errors: {
        500: `Server Error`,
      },
    });
  }

  /**
   * @param recallId 
   * @param formData 
   * @returns Int32_StringValueTuple Created
   * @throws ApiError
   */
  public static postRecallsPdf(
recallId: number,
formData?: {
file?: Blob;
},
): CancelablePromise<Int32_StringValueTuple> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/recalls/{recallId}/pdf',
      path: {
        'recallId': recallId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param recallId 
   * @returns void 
   * @throws ApiError
   */
  public static deleteRecallsPdf(
recallId: number,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/recalls/{recallId}/pdf',
      path: {
        'recallId': recallId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns RecallBrandCodeDto Success
   * @throws ApiError
   */
  public static getRecallsBrandCodes(): CancelablePromise<Array<RecallBrandCodeDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/recalls/brand-codes',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param recallId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postRecallsCopy(
recallId: number,
requestBody?: CopyRecallDto,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/recalls/{recallId}/copy',
      path: {
        'recallId': recallId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
        500: `Server Error`,
      },
    });
  }

}
